var D;!function(D){D.ENABLED="ENABLED",D.DISABLED="DISABLED"}(D||(D={}));var E=D;export{E as default};
